<div class="conatiner-div d-flex flex-column">
  <div class="topHead d-flex justify-content-between">
    <span>Search data</span>
    <div class="close-button" mat-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </div>
  </div>
  <div class="filter-div">
    <div class="d-flex flex-column input-div">
      <span class="input-text">Pincode</span>
      <input class="search-input dp-input-control" type="tel" placeholder="Enter pincode" aria-label="pincode"
        [formControl]="pin" (input)="getPincode($event)" maxlength="6"/>
    </div>
    @if(stateList.length <=1){
    <div class="d-flex flex-column input-div">
      <span class="input-text">State</span>
      <input class="search-input dp-input-control" type="tel" placeholder="Enter pincode first" aria-label="state"
        [formControl]="state" readonly/>
    </div>
}@else{
    <div class="d-flex flex-column input-div">
      <span class="input-text">State</span>
      <mat-form-field class="select-mat-form-field custom-select-form">
        <mat-select [formControl]="state" placeholder="Select State" class="custom-mat-select custom-select"
          (selectionChange)="onStateSelect(state)">
          <mat-option *ngFor="let option of stateList" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>

      </mat-form-field>
    </div>
}

  @if(districtList.length <=1){
    <div class="d-flex flex-column input-div">
      <span class="input-text">District</span>
      <input class="search-input dp-input-control" type="tel" placeholder="Enter pincode first" aria-label="district"
        [formControl]="district" readonly/>
    </div>
}@else{
    <div class="d-flex flex-column input-div">
      <span class="input-text">District</span>
      <mat-form-field class="select-mat-form-field custom-select-form">
        <mat-select [formControl]="district" placeholder="Select District" class="custom-mat-select custom-select"
          (selectionChange)="onDistrictSelect(district)">
          <mat-option *ngFor="let option of districtList" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>

      </mat-form-field>
    </div>
}

    <div class="d-flex btn-main-div">
      <button class="dp-secondary-btn btn-div" (click)="onClearClick()">
        Clear all
      </button>

      <button class="dp-primary-btn btn-div" (click)="onSearchClick()">
        Search
      </button>
    </div>
  </div>
</div>
